import NProgress from 'nprogress';
import Router from 'next/router';
import { trackPage } from './trackActions';

NProgress.configure({ showSpinner: false });

export default function manageRouteTransition() {
  let oldRoute = '';
  Router.onRouteChangeStart = () => {
    NProgress.start();
    if (window && window.googleyolo) {
      googleyolo.cancelLastOperation();
    }
  };

  Router.onBeforeHistoryChange = () => {
    oldRoute = location.pathname;
  };

  Router.onRouteChangeComplete = (route: string) => {
    const pagename = route;
    trackPage(pagename);
    if (oldRoute !== route.replace(/\?.+/g, '')) {
      window.scrollTo(0, 0);
    }
    NProgress.done();
  };
  Router.onRouteChangeError = () => NProgress.done();
}



// WEBPACK FOOTER //
// ./utils/routingManager.ts